import { createExternalRouteRef } from '@backstage/core-plugin-api';

export const collectionsMetricRouteRef = createExternalRouteRef({
  id: 'collections.metric',
  optional: true,
});

export const collectionsFlagRouteRef = createExternalRouteRef({
  id: 'collections.flag',
  optional: true,
});
